const generateNumericalDropdownOptionsUtil = (maxAge, minAge = 1) => {
  const ages = [];
  for (let ageIndex = minAge; ageIndex <= maxAge; ageIndex += 1) {
    ages.push(
      { value: ageIndex.toString(), label: ageIndex.toString() }
    );
  }
  return ages;
};

export default generateNumericalDropdownOptionsUtil;
